/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import {
  CheckCircleIcon,
  DotsHorizontalIcon,
  EyeIcon,
  InformationCircleIcon,
  ShieldExclamationIcon,
  UserRemoveIcon,
  XCircleIcon,
} from '@heroicons/react/solid';
import {
  Button,
  ButtonGroup,
  Card,
  Dropdown,
  FormCheck,
  OverlayTrigger,
  Tooltip,
  Image,
} from 'react-bootstrap';
import { ToggleAction } from './ToggleAction';
import { StorageModule } from '@vlinder-web/storage-module-react';

const getFirstLetterOfEachWord = (text) => text?.match(/\b\w/g).join('');

export const DomainTableRow = (props: any) => {
  const {
    id,
    verified,
    image,
    name,
    dateCreated,
    isSelected,
    selectUser,
    onTogglePress,
    onViewClick,
    role,
    validFrom,
    validUntil,
    description,
    data,
  } = props;
  const VerifiedIcon = verified ? CheckCircleIcon : InformationCircleIcon;
  const storageSrv = StorageModule?.getInstance();
  const userProfile = storageSrv.get('myProfile', 'session');

  const onToggle = (key: string) => {
    if (key === 'view') {
      onViewClick && onViewClick(data);
    } else {
      onTogglePress && onTogglePress(key, data);
    }
  };

  const renderCircle = (roles: any) => {
    const colors = ['008000', '800080', 'A52A2A', 'FF7F50', 'd2d2d2', '29A6A6'];

    const output: any = [];

    const returnImg = () => {
      if (Array.isArray(roles)) {
        roles?.forEach((item, index) => {
          output.push(
            <li className="d-inline-block">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">{item}</Tooltip>}
              >
                <Image
                  style={{ width: '40px' }}
                  className="img-40 rounded-circle"
                  src={`https://ui-avatars.com/api/?name=${item}&background=${colors[index]}&color=fff`}
                />
              </OverlayTrigger>
            </li>
          );
        });
      }
      if (typeof role === 'string') {
        const randomIndex = Math.floor(Math.random() * colors.length);
        output.push(
          <li className="d-inline-block">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip className="m-0">{role}</Tooltip>}
            >
              <Image
                style={{ width: '40px' }}
                className="img-40 rounded-circle"
                src={`https://ui-avatars.com/api/?name=${role}&background=${colors[randomIndex]}&color=fff`}
              />
            </OverlayTrigger>
          </li>
        );
      }
      return output;
    };

    return (
      <div
        className="roleAvatar"
        style={{ width: '100%', inlineSize: 'max-content' }}
      >
        <ul style={{ paddingLeft: '0px' }}>{returnImg()}</ul>
      </div>
    );
  };

  return (
    <tr className="border-bottom">
      <td>
        <FormCheck type="checkbox" className="dashboard-check">
          <FormCheck.Input
            id={`user-${id}`}
            checked={isSelected}
            onChange={() => selectUser(id)}
          />
          <FormCheck.Label htmlFor={`user-${id}`} />
        </FormCheck>
      </td>
      <td>
        <Card.Link className="d-flex align-items-center">
          {image ? (
            <Image src={image} className="avatar rounded-circle me-3" />
          ) : (
            <div className="avatar d-flex align-items-center justify-content-center fw-bold rounded bg-secondary me-3">
              <span>{name && getFirstLetterOfEachWord(name)}</span>
            </div>
          )}
          <div className="d-block">
            <span className="fw-bold">{name}</span>
          </div>
        </Card.Link>
      </td>
      <td>
        <span className="fw-normal">{description}</span>
      </td>
      <td>
        <span className="fw-normal">{validFrom}</span>
      </td>
      <td>
        <span className="fw-normal">{validUntil}</span>
      </td>
      <td>
        <span className="fw-normal">{dateCreated}</span>
      </td>
      <td>
        <ToggleAction status={status} onTogglePress={onToggle} />
      </td>
    </tr>
  );
};
